// extracted by mini-css-extract-plugin
export default {"box":"termsAndConditionsListPage_box__LRqg1"};